import gql from 'graphql-tag';

export const GET_ALL_SETTING_DAYS = gql`
    query(
        $golf_group_code: String!
    ){
    GetAllSettingDays(
        golf_group_code: $golf_group_code
    ){
        AllSettingDays{
            month_day
            date_name
            date_type
        }
    }
  }
`;